export default "__VITE_ASSET__m0XX8ZQK__"